<template>
    <div>
        <div>
            <el-form :model="queryForm" :inline="true"  style="text-align:left;">                
                <el-form-item label="展示端:">
                    <My-Select v-model="queryForm.clientType" :objSelect="queryForm.clientType" :options="options" :placeholder="placeholder" @changeSelct="changeSelctQuery"></My-Select>                 
                </el-form-item> 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="shufflingEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="shufflingEditor('update',scope.row)">修改</el-button>
                    <el-button size="mini" type="primary" @click="shufflingDelete(scope.row)">删除</el-button>
                </template>
            </My-table> 
        </div>
        
        <el-dialog :title="title" :visible.sync="shufflingDialog" :close-on-click-modal=false width="1000px">
            <el-form :model="editorForm" :inline="true" :rules="rules" ref="editorForm" label-width="130px" style="text-align:left">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="展示端:" prop="clientType" class="show-select">
                            <My-Select v-model="editorForm.clientType" :objSelect="editorForm.clientType" :options="options1" :placeholder="placeholder" @changeSelct="changeSelctForm"></My-Select> 
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="图片展示顺序:" prop="sn" class="sn-input" >
                            <el-input type= "number" v-model="editorForm.sn" placeholder="请输入图片展示顺序"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发布时间:" prop="releaseTime" class="release-input">
                            <el-date-picker  :picker-options="pickerOptions" v-model="editorForm.releaseTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="截止时间:" prop="endTime" class="release-input">
                            <el-date-picker :picker-options="pickerOptions" v-model="editorForm.endTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </el-form-item>   
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="图片上传:" prop="picUrl" >
                            <el-upload
                                class="avatar-uploader"
                                action="/extwarapi/api/file/fileUpload"                    
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="this.editorForm.picUrl" :src="this.editorForm.picUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item class="jumper-checkbox">
                            <el-checkbox  v-model="editorForm.jumpState" @change="jumper" >可跳转</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-show="jumpUrlTag">
                        <el-form-item label="跳转URL:" prop="jumpUrl" class="sn-input" ref="jumpUrlFormItem">
                            <el-input v-model="editorForm.jumpUrl"  placeholder="请输入跳转URL"></el-input>
                        </el-form-item>                        
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                <el-button @click="resetForm('editorForm')">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import common from "../../../public/static/common.js";
export default { 

    name: 'serviceProject',
    data(){
        var validateReleaseTime= (rule, value, callback) => {
            let start =new Date(value) ;
            let end=new Date(this.editorForm.endTime); 
            if(this.editorForm.endTime!==''){
                if (start.getTime() > end.getTime()) {
                    callback(new Error('发布时间应小于截止时间'));
                } else {
                    callback();
                }
            }            
        };
        var validateEndTime= (rule, value, callback) => {
            let end=new Date(value) ;
            let start=new Date(this.editorForm.releaseTime);           
            if (end.getTime() < start.getTime()) {                                     
                callback(new Error('截止时间应大于发布时间'));
            } else {
                callback();
            }
        };
        return{
            title:'',
            pickerOptions: {             
                disabledDate:function(dt){
                    if(dt.getTime()<(new Date).getTime())  return true;
                }
            },
            jumpUrlTag:false,
            placeholder:'请选择查询状态',
            queryForm:{
                clientType:''
            },
            editorForm:{
                id:'',
                clientType:'',
                sn:'',
                releaseTime:'',
                endTime:'',
                picUrl:'',
                jumpUrl:'',
                jumpState:false,
                modifyUser:'',
                createUser:''
            },
             // 列表配置
            configurationData:[
                {
                    title: '展示端',
                    propertys: 'clientTypeName',
                    width: ''
                },
                {
                    title: '图片展示顺序',
                    propertys: 'sn',
                    width: ''
                },
                {
                    title: '发布时间',
                    propertys: 'releaseTime',
                    width: ''
                },
                {
                    title: '截止时间',
                    propertys: 'endTime',
                    width: ''
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/picturesManage/page',
                param:''
            },
            shufflingDialog:false,
            options:[
                {"key":'',"value":'全部'},
                {"key":'S',"value":'销售端'},
                {"key":'U',"value":'用户端'}
            ],
            options1:[
                {"key":'S',"value":'销售端'},
                {"key":'U',"value":'用户端'}
            ],
            operationType:'',
            rules: {
                clientType: [
                    { required: true, message: '请选择展示端', trigger: 'blur' }
                ],
                sn: [
                    { required: true, message: '请输入图片展示顺序', trigger: 'blur' }
                ],
                picUrl: [
                    { required: true, message: '请上传图片', trigger: 'blur' }
                ],
                releaseTime: [
                    {  required: true, message: '请选择发布时间', trigger: 'blur' },
                    {  validator: validateReleaseTime,}
                ],
                endTime: [
                    {  required: true, message: '请选择截止时间', trigger: 'blur' },
                    {  validator: validateEndTime,}
                ],
                jumpUrl: [
                    { required: true, message: '请选择跳转URL', trigger: 'blur' }
                ],
            }
        }
    },
    methods:{
        shufflingEditor(operationType,row){
            this.operationType=operationType;
            if(operationType=='update'){
                this.title='轮播图修改';
                this.editorForm.id=row.id;
                this.editorForm.clientType=row.clientType;
                this.editorForm.sn=row.sn;
                this.editorForm.releaseTime=row.releaseTime;
                this.editorForm.jumpUrl=row.jumpUrl;
                this.editorForm.endTime=row.endTime;
                this.editorForm.picUrl=row.picUrl;
                if(row.jumpState=='Y'){
                    this.editorForm.jumpState=true;
                    this.jumpUrlTag=true;
                    this.editorForm.jumpUrl=row.jumpUrl;
                }else{
                    this.editorForm.jumpState=false;
                    this.jumpUrlTag=false;
                } 
            }else{
                //添加
                this.title='轮播图新增';
                this.editorForm.jumpState=false;
                this.editorForm=common.emptyModel(this.editorForm,["jumpState"]);
            }
            this.shufflingDialog=true;           
        },
        query(){
            this.getTableParam.param=this.queryForm
            this.$refs.myTable.query(1);
        },
        submitForm(formName) {
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.editorForm);
                param.createUser=usercode;
                param.modifyUser=usercode;
            if(param.jumpState){
                param.jumpState='Y';
            }else{
                param.jumpState='N';
            }

            if(this.operationType=='add'){
                url="/extwarapi/api/picturesManage/add";
            }else{
                url="/extwarapi/api/picturesManage/update";
            }
            let validFields=["clientType","sn","releaseTime","endTime","picUrl"];

            if(param.jumpState=="Y" ){
                validFields.push("jumpUrl");
            }

            let me = this;
            let allValid = true;
            this.$refs[formName].validateField(validFields,(valid) => {
                if(valid.length>0){
                    allValid = false;
                }                
            });

            if (allValid) {
                me.axios.post(url, param).then((resp) => {
                    if(resp.data.code=='0000'){
                        this.$alert("操作成功!", '提示信息', {
                            confirmButtonText: '确定',
                            callback: action => {
                                me.shufflingDialog=false;
                                me.$refs["myTable"].query(1);  
                            }
                        });
                    }else{
                        this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                             });
                        return;
                    }  
              
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
            } else {
                //console.log('error submit!!',allValid);
                return false;
            }
           
        },
        resetForm(formName) {
            this.shufflingDialog=false;
            this.$refs[formName].resetFields(); 
        }, 
        handleAvatarSuccess(res, file) {
            this.editorForm.picUrl = res.result
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || 'image/png' ;
            const isLt5M = file.size / 1024 / 1024 < 5;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
            }
            if (!isLt5M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }

            this.imageUrl = file.url;

            return isJPG && isLt5M;
        },
        jumper(value){
            if(value){
                this.jumpUrlTag=true;
            }else{
                this.jumpUrlTag=false;
            }
        },
        changeSelctForm(value){           
            this.editorForm.clientType=value;
        },
        changeSelctQuery(value){
            this.queryForm.clientType=value;
        },
        shufflingDelete(row){
            let url='/extwarapi/api/picturesManage/delete';
            let param={
                id:row.id,
                modifyUser:'',
                };
            this.$confirm('确定删除吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.axios.post(url, param).then((resp) => {  
                            this.shufflingDialog=false;
                            this.$refs["myTable"].query();                
                        }).catch((resp) => {
                            //console.log('error', resp); 
                        })
                    }).catch(() => {
                        this.shufflingDialog=false;   
                    });
        }
       
    }

}
</script>
<style lang="scss"  >
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border:1px dashed rgb(223, 215, 215);
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.show-select .el-input--suffix{
    width: 260px;
}
.release-input .el-input__inner{    
    width: 260px;
}
.sn-input .el-input__inner{    
    width: 260px;
}
</style>